import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "menu-nav" }
const _hoisted_2 = {
  key: 0,
  class: "fa-solid fa-chevron-down dashboard-user-chevron"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-tie" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-shield" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }, null, -1)

import { ref, onMounted, watch, computed } from "vue";

import store from "@/store/index";
import { useRouter } from "vue-router";
import { useCookies } from "vue3-cookies";
import { USER, USER_LOGINED } from "@/const/cookie";
import commons from "@/utils/Common";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfor',
  props: {
    variant: { default: "default" }
  },
  setup(__props: any) {


const { cookies } = useCookies();
const router = useRouter();
const name = ref("");
const url = ref("");
const logOut = async () => {
  commons.logOut();
  router.push({ path: "/sign-in" });
};
const inform = async () => {
  router.push({ path: "/inform" });
};
const urlAvatar = computed(() => {
  return store.getters.isUrlAvatar;
});
const changePassword = async () => {
  router.push({ path: "/change-password" });
};
onMounted(() => {
  let user = cookies.get(USER);
  if (user != null && user != undefined) {
    name.value = user.name;
    url.value = user.urlAvatar;
  }
});

watch(urlAvatar, (newValue, oldValue) => {
  url.value = JSON.parse(JSON.stringify(newValue));
});

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, null, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { onClick: inform }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('text.userInformation')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { onClick: changePassword }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('text.changePass')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { onClick: logOut }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('text.logOut')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "el-dropdown-link",
          onClick: inform
        }, [
          _createVNode(_component_el_avatar, {
            size: "small",
            src: url.value
          }, null, 8, ["src"]),
          _createVNode(_component_el_link, { class: "user-name" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(name.value), 1)
            ]),
            _: 1
          }),
          (_ctx.variant === 'dashboard')
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})